import Vue from 'vue'
import Vuex from 'vuex'
import io from "socket.io-client";
import helper from './../helper/_helpers'; // 👈 import your helper

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        socket: null,
        user: {},
        haveAnnouncements: false,
        totalUnpaidInvoices: 0,
        updateVersion: 0,
        walkInStartDate: '',
        settings: null,
        updates: [],
        sources: [],
        paymentMasters: [],
        client: null,
        fullWidth: false,
        sideBarState: '',
        mobileOpened: false, // check and remove
        appSidebarClass: '', // check and remove
        appMenuBarClass: '', // check and remove
        houses: {
            state: '',
            message: '',
            list: []
        },
        fistHouseId: '',
        walkInData: {
            action: 'FINISHED_RESERVATION',
            checkIn: '',
            checkOut: '',
            WalkInId: '0',
            time: ''
        },
        roomRemovedDate: '',
        totalUnReadMails: 0,
        mailBoxCounts: [],
        currentReservationId: 0,
        reservationMessages: [],
        showNotification: false,
        notification: null,
        overDue: {
            have: false,
            days: 0
        }
    },
    mutations: {

        setOverDue (state, days) {
            state.overDue = {
                have: true,
                days: days
            }
        },
        setSocket(state, socketInstance) {
            state.socket = socketInstance;
        },
        setHaveAnnouncements(state, status) {
            state.haveAnnouncements = status
        },
        setTotalUnPaidInvoices(state, total) {
            state.totalUnpaidInvoices = total
        },
        setWalkMade(state, response) {
            state.walkInData.checkIn = response?.checkIn || ''
            state.walkInData.checkOut = response?.checkOut || ''
            state.walkInData.WalkInId = response?.id || 0
            state.walkInData.action = response?.action || ''
            state.walkInData.time = new Date().toTimeString()
        },
        setTotalNewMails(state, count) {
            state.totalUnReadMails = count
        },
        setMailCounts(state, array) {
            state.mailBoxCounts = array
        },
        setWalkInState(state, data) {
            state.walkInState = data
        },
        setWalkInId(state, data) {
            state.WalkInId = data
        },
        setRoomRemoved(state, data) {
            state.roomRemovedDate = data
        },
        setSideBarState(state, data) {
            state.sideBarState = data
        },
        setLoggedUser(state, data) {
            state.user = data
        },
        setProfileSounds(state, data) {
            state.user = {
                ...state.user,
                messageNotificationSound: parseInt(data.messageNotificationSound) === 1,
                successNotificationSound: parseInt(data.successNotificationSound) === 1,
                errorNotificationSound: parseInt(data.errorNotificationSound) === 1
            }
        },
        setHouseLoading(state) {
            state.houses.state = 'loading'
        },
        setHouseError(state, data) {
            state.houses.state = 'error'
            state.houses.message = data.error
        },
        setHouseList(state, data) {
            state.houses.state = 'success'
            state.houses.message = ''
            state.houses.list = data.list
            state.fistHouseId = data.list[0].id
        },
        setSettings(state, data) {
            state.settings = data.settings
            state.client = data.client
            state.sources = data.sources
            state.paymentMasters = data.paymentMasters
        },
        setUpdateInfos(state, data) {
            state.updates = data.updates
            state.updateVersion = data.updateVersion
        },
        setSettingsAccountCodes(state, data) {
            state.settings.accounting = data
        },
        setSidebarHideClass(state) {
            state.appSidebarClass = 'mobile hide'
            state.appMenuBarClass = 'd-block'
        },
        setSidebarShowClass(state) {
            state.appSidebarClass = ''
            state.appMenuBarClass = 'd-none'
        },
        openCloseMenu(state) {
            if (state.mobileOpened) {
                state.mobileOpened = false
                state.appSidebarClass = 'mobile hide'
            } else {
                state.mobileOpened = true
                state.appSidebarClass = 'mobile show'
            }
        },
        setHideNotification (state) {
            state.showNotification = false
        },
        cleanReservationMessages (state, payload) {
            state.reservationMessages = []
        },
        setReservationMessages (state, payload) {
            const direction = payload.direction
            const messages = payload.messages
            if (direction === 'old') {
                state.reservationMessages.unshift(...messages);
            } else {
                state.reservationMessages.push(...messages)
            }
        },
        setReservationMessage (state, completeBody) {
            const singleMessage = completeBody.content
            if (state.user.messageNotificationSound) {
                helper.playNotification()
            }
            if (state.currentReservationId === parseInt(singleMessage.reservationId)) {
                const oldMessage = state.reservationMessages.find(msg => msg.id === singleMessage.id)
                if (oldMessage) {
                    oldMessage.status = singleMessage.status;
                } else {
                    state.reservationMessages.push(singleMessage)
                }
            } else {
                state.showNotification = true
                state.notification = {
                    type: 'CHAT_NOTIFICATION',
                    content: completeBody.body
                }
            }
        },
        setCurrentReservationId (state, reservationId) {
            state.currentReservationId = parseInt(reservationId)
        }
    },
    actions: {
        setOverDue ({commit}, days) {
            commit("setOverDue", days)
        },
        setCurrentReservationId({commit}, reservationId) {
          commit("setCurrentReservationId", reservationId)
        },
        cleanReservationMessages ({commit}, payload) {
            commit('cleanReservationMessages', []);
        },
        setReservationMessages ({commit}, payload) {
            commit('setReservationMessages', payload);
        },
        hideNotification ({commit, state}) {
            commit('setHideNotification');
        },
        initSocket({ commit, state }) {

            const clientId = parseInt(state.settings.clientId)

            const socket = io(Vue.prototype.$socketUrl, {
                query: { clientId: clientId }
            });

            socket.on('connect', () => {
            });

            socket.on('connect_error', (err) => {
                console.error('❌ Connection error:', err.message);
            });

            socket.on('disconnect', () => {
            });

            socket.on('onChatNotification', (messageBody) => {
                if (parseInt(messageBody.clientId) === clientId) {
                    commit('setReservationMessage', {
                        body: messageBody.body,
                        content: messageBody.content
                    });
                }
            });
            commit('setSocket', socket);
        }
    },
    getters: {
        socket: (state) => state.socket
    },
    modules: {}
})
export default store
